export interface DeviceForensicsResponse {
  deviceId: string
  forensics: DeviceForensic[]
}

export interface FileEventResponse {
  events: FileEvent[]
  totalPages: number
  totalCount: number
}

export interface DeviceForensic {
  deviceIdentifier: string
  shortPath?: string
  path: string
  size?: number
  items?: number
  created?: string
  modified?: string
  firstSeen?: string
  lastSeen?: string
  changed?: string
  accessCode?: string
  inodeVersions?: number[]
  isStub: boolean
  children: DeviceForensic[]
  mounts: Mount[]
  deleted?: boolean
  deletedTimestamp?: string
  fileEventCount?: number
}

interface Mount {
  firstSeen?: string
  lastSeen?: string
  mountedFrom?: string
  mountPoint?: string
  files?: number
  blockSize?: number
  mountFlags?: number
  freeFiles?: number
  availableBytes?: number
  freeBytes?: number
  totalBytes?: number
  fileSystemType?: string
}

export interface FileEvent {
  eventType: string
  timestamp: string
  inode?: number
  severity: string
  eventDetails: string
}

export enum FileEventType {
  FILE_REAPPEARED = 'FILE_REAPPEARED',
  CRASHLOG_CREATED = 'CRASHLOG_CREATED',
  CRASHLOG_REAPPEARED = 'CRASHLOG_REAPPREARED',
  SYSDIAGNOSE_CREATED = 'SYSDIAGNOSE_CREATED',
  SYSDIAGNOSE_REAPPEARED = 'SYSDIAGNOSE_REAPPREARED',
  CRASHLOG_DELETED = 'CRASHLOG_DELETED',
  SYSDIAGNOSE_DELETED = 'SYSDIAGNOSE_DELETED',
  ITEM_COUNT_CHANGED = 'ITEM_COUNT_CHANGED',
  JAILBREAK_BEHAVIOUR_DETECTED = 'JAILBREAK_BEHAVIOUR_DETECTED',
  EMPTY_DIRECTORY = 'EMPTY_DIRECTORY',
  INODE_CHANGED = 'INODE_CHANGED',
  PATH_CHANGED = 'PATH_CHANGED',
  RECORD_DELETED = 'RECORD_DELETED',
  FS_METADATA_CREATED = 'FS_METADATA_CREATED',
}

export function getEventTypeLabel(eventType: string): string {
  switch (eventType) {
    case FileEventType.FS_METADATA_CREATED:
      return 'FS Diagnostics Created'
    default:
      return eventType
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
  }
}
